import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';

import Dialog from '../../components/Dialog/Dialog';
import styles from './DownloadCancel.module.less';
import { downloadCanenl, downloadCancelSoft } from '../../actions/downloadTask';

import { logging } from '../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownloadCancel = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.downloadCanelShow,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const downloadCancel = useSelector(selectDownloadCancel);

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Simulator_Suspend',
        label: '',
      }),
    );
  }, []);

  const handleInterrupt = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Simulator_Suspend_Y',
        label: '',
      }),
    );
    dispatch(downloadCancelSoft({ ...downloadCancel?.info }));
    dispatch(downloadCanenl({ isShow: false }));
  };

  const handleWait = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Simulator_Suspend_N',
        label: '',
      }),
    );
    dispatch(downloadCanenl({ isShow: false }));
  };

  return (
    <Dialog
      title="温馨提示"
      maskStyle={styles.mask}
      containerStyle={styles.containerStyle}
      handleClose={() => dispatch(downloadCanenl(false))}
    >
      <div className="desc">
        正在为您准备运行此应用所必须的模拟器环境，若中断将无法使用任何安卓应用。
      </div>
      <div className="operate">
        <div className="btn" onClick={handleInterrupt}>
          确认中断
        </div>
        <div className="btn_creat" onClick={handleWait}>
          再等等
        </div>
      </div>
    </Dialog>
  );
});
